module.exports = __webpack_public_path__ + "e31fcf1885e371e19f5786c2bdfeae1b.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Bold.ttf
// module id = 82
// module chunks = 0